import { render, staticRenderFns } from "./CustomerConfirmFormNewVersion.vue?vue&type=template&id=54199f82&scoped=true"
import script from "./CustomerConfirmFormNewVersion.vue?vue&type=script&lang=js"
export * from "./CustomerConfirmFormNewVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54199f82",
  null
  
)

export default component.exports